import * as z from 'zod';

// Types
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoZod } from '@/types/SeoType';
import { TagZod } from '@/types/TagType';
import { TitleZod } from '@/types/TitleType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

export const OfferZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  title: TitleZod,
  paragraph: ParagraphZod.nullable(),
  titleOverview: TitleZod,
  paragraphOverview: ParagraphZod,
  labelOverview: z.string(),
  tags: z.array(TagZod).nullable(),
  blocks: z.array(blocksSchemaZod),
  seo: SeoZod,
});

export type OfferType = z.infer<typeof OfferZod>;

export const OfferSlugZod = OfferZod.pick({
  id: true,
  documentId: true,
  slug: true,
  seo: true,
});

export type OfferSlugType = z.infer<typeof OfferSlugZod>;
